module.exports = __webpack_public_path__ + "img/connect-docker.0708e061.png";